type MountRoot = Pick<HTMLElement, 'hasAttribute' | 'hasChildNodes'>;

// Client-only routes receive an SEO heading in their prerendered document, but
// that heading is not React SSR output and must be replaced instead of hydrated.
export function shouldHydrateRoot(root: MountRoot, prerenderedPath: boolean): boolean {
  return prerenderedPath && root.hasChildNodes() && !root.hasAttribute('data-client-render');
}
